import { Link } from "react-router-dom";

import "./LandingNavBar.scss";

const LandingNavBar = () => {
  return (
    <header className="navbar-container">
      {/* =======================================================
          BRAND
      ======================================================== */}

      <Link className="navbar-logo-container" to="/" aria-label="Postly home">
        <div className="navbar-logo-content">
          <img
            className="company-logo"
            src="/assets/company-logo.svg"
            alt=""
            aria-hidden="true"
          />

          <span className="company-logo-text">Postly</span>
        </div>
      </Link>

      {/* =======================================================
          RIGHT SIDE
      ======================================================== */}

      <div className="navbar-right-container">
        {/* Static marketing pages */}
        <nav className="navbar-menu-container" aria-label="Primary navigation">
          <div className="navbar-menu-item-container">
            <a className="navbar-menu-item" href="/about">
              About
            </a>
          </div>

          <div className="navbar-menu-item-container">
            <a className="navbar-menu-item" href="/features">
              Features
            </a>
          </div>

          <div className="navbar-menu-item-container">
            <a className="navbar-menu-item" href="/use-cases">
              Use Cases
            </a>
          </div>

          <div className="navbar-menu-item-container">
            <a className="navbar-menu-item" href="/pricing">
              Pricing
            </a>
          </div>
        </nav>

        {/* React auth routes */}
        <div className="navbar-actions-container">
          <Link className="navbar-sign-in" to="/auth">
            Sign In
          </Link>

          <Link className="navbar-get-started" to="/auth/sign-up">
            Get Started
          </Link>
        </div>
      </div>
    </header>
  );
};

export default LandingNavBar;
